/** @format */

import { CsvImportManagement } from "../../components/CsvImportManagement";
import { useBrand } from "../../hooks/useBrand";
import { useImportJobs } from "../../hooks/useImportJobs";

export const AdminImportManagementPage = () => {
	const { brand } = useBrand();
	const { jobs, isLoading, error, reload } = useImportJobs(brand);

	return (
		<section className="space-y-6">
			<div>
				<h2 className="text-[1.75rem] font-bold text-(--admin-color-primary)">Import history</h2>
				<p className="mt-2 text-sm text-slate-600">Manage imported questions</p>
			</div>
			{isLoading && (
				<p role="status" className="text-sm text-slate-600">
					Loading import jobs…
				</p>
			)}

			{error && (
				<div
					role="alert"
					className="rounded-lg border text-center border-red-200 bg-red-50 p-6 shadow-(--admin-shadow-raised)"
				>
					<p className="font-semibold text-red-900">Failed to load import jobs</p>
					<p className="mt-1 text-sm text-red-900">{error}</p>
					<button
						type="button"
						onClick={reload}
						className="mt-4 cursor-pointer rounded-md border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
					>
						Retry
					</button>
				</div>
			)}
			{!isLoading && !error && <CsvImportManagement jobs={jobs} />}
		</section>
	);
};
